Alpine.data('GeoContainer', (allCountries, defaultCountry) => ({
    userCountry: '',

    init() {
        this.getUserCountry();
    },

    getUserCountry() {
        fetch('/api/geo/country')
            .then(response => response.json())
            .then(data => {
                const iso = data.iso;
                this.userCountry = allCountries.includes(iso) ? iso : defaultCountry;
            })
            .catch(error => {
                console.error('Error fetching the country:', error);
                this.userCountry = defaultCountry;
            });
    }
}));
